import { render, staticRenderFns } from "./approveInfo.vue?vue&type=template&id=56c9ae08&scoped=true&"
import script from "./approveInfo.vue?vue&type=script&lang=js&"
export * from "./approveInfo.vue?vue&type=script&lang=js&"
import style0 from "./approveInfo.vue?vue&type=style&index=0&id=56c9ae08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c9ae08",
  null
  
)

export default component.exports